import api from "../../../services/api";
import config from "../../../config";

const mc_role = localStorage.getItem("mc_role");

/**
 * Fetch a single maker-checker action by mc_id (plain integer, used for direct URL access)
 */
export const getByMcId = async (mc_id) => {
  const result = await api({
    url: "/makerchecker/getMackerCheckerAction",
    method: "POST",
    data: { mc_id: Number(mc_id) },
  });
  return result?.data || null;
};

/**
 * LineItems MakerChecker API Routes
 */
export const lineItemsApi = {
  getTotalCount: async (type) => {
    const result = await api({
      url: "/makerchecker/getTotalCountLineItems",
      method: "POST",
      data: { type, mc_role },
    });
    return result.data || {};
  },

  getPending: async (page, type, search = "") => {
    const result = await api({
      url: "/makerchecker/getPendingLineItemRequests",
      method: "POST",
      data: { search, limit: config.PER_PAGE, page, type, mc_role },
    });
    return result.data || [];
  },

  getApproved: async (page, type, search = "") => {
    const result = await api({
      url: "/makerchecker/getApprovedLineItemRequests",
      method: "POST",
      data: { search, limit: config.PER_PAGE, page, type, mc_role },
    });
    return result.data || [];
  },

  getRejected: async (page, type, search = "") => {
    const result = await api({
      url: "/makerchecker/getRejectedLineItemRequests",
      method: "POST",
      data: { search, limit: config.PER_PAGE, page, type, mc_role },
    });
    return result.data || [];
  },

  approve: async (mc_id) => {
    const result = await api({
      url: "/makerchecker/ApproveLineItemRequest",
      method: "POST",
      data: { mc_id },
    });
    return result;
  },

  reject: async (mc_id, reason) => {
    const result = await api({
      url: "/makerchecker/RejectLineItemRequest",
      method: "POST",
      data: { mc_id, reason },
    });
    return result;
  },
};

/**
 * Users MakerChecker API Routes
 */
export const usersApi = {
  getTotalCount: async (type) => {
    const result = await api({
      url: "/makerchecker/getTotalCountUsers",
      method: "POST",
      data: { type },
    });
    return result.data || {};
  },

  getPending: async (page, type) => {
    const result = await api({
      url: "/makerchecker/getPendingUserRequests",
      method: "POST",
      data: { limit: config.PER_PAGE, page, type },
    });
    return result.data || [];
  },

  getApproved: async (page, type) => {
    const result = await api({
      url: "/makerchecker/getApprovedUserRequests",
      method: "POST",
      data: { limit: config.PER_PAGE, page, type },
    });
    return result.data || [];
  },

  getRejected: async (page, type) => {
    const result = await api({
      url: "/makerchecker/getRejectedUserRequests",
      method: "POST",
      data: { limit: config.PER_PAGE, page, type },
    });
    return result.data || [];
  },

  approve: async (mc_id) => {
    const result = await api({
      url: "/makerchecker/approveUserRequest",
      method: "POST",
      data: { mc_id },
    });
    return result;
  },

  reject: async (mc_id, reason) => {
    const result = await api({
      url: "/makerchecker/rejectUserRequest",
      method: "POST",
      data: { mc_id, reason },
    });
    return result;
  },
};

const brandRole = (activeRole) =>
  activeRole === "checker" || localStorage.getItem("mc_role") === "2" ? "checker" : "maker";

export const brandsApi = {
  getTotalCount: async (activeRole) => {
    const result = await api({
      url: "/makerchecker/getTotalCountBrands",
      method: "POST",
      data: { type: brandRole(activeRole) },
    });
    return result.code === 200 ? result.data || {} : result.data || {};
  },

  getPending: async (page, activeRole) => {
    const result = await api({
      url: "/makerchecker/getPendingBrandRequests",
      method: "POST",
      data: { page, limit: config.PER_PAGE, type: brandRole(activeRole) },
    });
    return result.code === 200 ? result.data || [] : result.data || [];
  },

  getApproved: async (page, activeRole) => {
    const result = await api({
      url: "/makerchecker/getApprovedBrandRequests",
      method: "POST",
      data: { page, limit: config.PER_PAGE, type: brandRole(activeRole) },
    });
    return result.code === 200 ? result.data || [] : result.data || [];
  },

  getRejected: async (page, activeRole) => {
    const result = await api({
      url: "/makerchecker/getRejectedBrandRequests",
      method: "POST",
      data: { page, limit: config.PER_PAGE, type: brandRole(activeRole) },
    });
    return result.code === 200 ? result.data || [] : result.data || [];
  },

  approve: async (mc_id, route) => {
    const result = await api({
      url: route,
      method: "POST",
      data: { mc_id, isapprove: true },
    });
    return result;
  },

  reject: async (mc_id, reason, route) => {
    const result = await api({
      url: route,
      method: "POST",
      data: { mc_id, isapprove: false, rejreason: reason },
    });
    return result;
  },
};

/**
 * Adunit Position Slot Status MakerChecker API Routes
 */
export const adunitPositionSlotStatusApi = {

  getTotalCount: async (type) => {
    const result = await api({
      url: "/makerchecker/getTotalCountAdunitPosSlotStatus",
      method: "POST",
      data: { type },
    });
    return result.data || {};
  },

  getPending: async (page, type) => {
    const result = await api({
      url: "/makerchecker/getAdunitPositionSlotStatusRequests",
      method: "POST",
      data: { limit: config.PER_PAGE, page, req_type: 0, type },
    });
    return result.data || [];
  },
  getApproved: async (page, type) => {
    const result = await api({
      url: "/makerchecker/getAdunitPositionSlotStatusRequests",
      method: "POST",
      data: { limit: config.PER_PAGE, page, req_type: 1, type },
    });
    return result.data || [];
  },
  getRejected: async (page, type) => {
    const result = await api({
      url: "/makerchecker/getAdunitPositionSlotStatusRequests",
      method: "POST",
      data: { limit: config.PER_PAGE, page, req_type: 2, type },
    });
    return result.data || [];
  },

  approve: async (mc_id) => {
    const result = await api({
      url: "/makerchecker/approveRejectAdunitPosSlotStatus",
      method: "POST",
      data: { mc_id, isapprove: true },
    });
    return result;
  },

  reject: async (mc_id, reason) => {
    const result = await api({
      url: "/makerchecker/approveRejectAdunitPosSlotStatus",
      method: "POST",
      data: { mc_id, isapprove: false, rejreason: reason },
    });
    return result;
  },
};